/*
  Gets the uuid from the search params and sends the unsubscribe request to
  reware-api.  if no uuid found or the api call fails, it redirects to
  the homepage.
*/
async function unsubscribeWish() {
  const urlParams = new URLSearchParams(window.location.search);
  const wishUuid = urlParams.get('wis');

  if (wishUuid) {
    const { wishUnsubscribe: data } = await wishUnsubscribe(wishUuid);
    if(data) {
      renderUnsubscribe(data)
    } else {
      window.location = window.Shopify.routes.root;
    }
  } else {
    window.location = window.Shopify.routes.root;
  }
}

/**
 * unsubscribe a wish
 * @param {*} wishUuid
 * @returns {Object} the uuid of the unsubscribed wish and the CatalogItem title
 */
async function wishUnsubscribe(wishUuid) {
  const query = `
      mutation wishUnsubscribe(
        $wishUuid: String!
      ) {
        wishUnsubscribe(wishUuid: $wishUuid){
          uuid
          catalogItem {
            title
          }
        }
      }
    `;
  const param = 'mutation-wishUnsubscribe';
  try {
    const response = await fetchWithAppName(`${global.url}${param}`, {
      body: JSON.stringify({ query, variables: { wishUuid } }),
      method: 'POST'
    });
    const jsonData = await response.json();
    return jsonData.data;
  } catch (e) {
    console.error(e);
  }
}

async function renderUnsubscribe(data) {
  document.querySelector('.unsubscribe__product-title').textContent = data?.catalogItem?.title;
}

unsubscribeWish();